import React from "react";
import PropTypes from "prop-types";
import { get } from "lodash";
import { LoadMoreStoriesBase } from "@quintype/components";

import { GA, WebEngage, DeepBI, EVOLOK } from "../../../integrations";
import styles from "./styles.m.css";
import { VikatanDesktopSticky, VikatanSticky } from "../../rows/ad-free";

import MyvikatanCollection from "../../rows/myvikatan-collection";
import MyVikatanHeader from "../../rows/myvikatan-header";
import { LoadMoreButton } from "../../atoms/read-more-link";
import StoryCardVertical from "../../atoms/story-card-vertical";
import { FIELDS_FOR_STORY_PAGE } from "../../../constants";

const StoryList = ({ stories }) =>
  stories.length > 0 ? (
    <React.Fragment>
      {stories.map((story, idx) => {
        return (
          <div key={idx} className={styles["story-card"]}>
            <StoryCardVertical story={story} key={story.id} />
          </div>
        );
      })}
    </React.Fragment>
  ) : (
    <h3 className={styles["no-results"]}>No results found</h3>
  );

StoryList.propTypes = {
  stories: PropTypes.arrayOf(StoryCardVertical.propTypes.story)
};

const StoryListBase = ({ stories, loading, onLoadMore, noMoreStories }) => (
  <React.Fragment>
    <div className={`${styles["default-section-page"]} ${styles["default-section-page-container"]}`}>
      <div className={styles["section-page"]}>
        <StoryList stories={stories} />
      </div>
    </div>
    {!noMoreStories &&
      stories.length >= 12 && (
        <div className={styles["load-more-wrap"]}>
          <LoadMoreButton text={loading ? "LOADING..." : " மேலும் படிக்க"} disabled={loading} onClick={onLoadMore} />
        </div>
      )}
  </React.Fragment>
);

export { StoryListBase };

StoryListBase.propTypes = {
  stories: PropTypes.arrayOf(StoryCardVertical.propTypes.story),
  loading: PropTypes.bool,
  onLoadMore: PropTypes.func,
  noMoreStories: PropTypes.bool
};

export class MyVikatanSectionPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      random: 0
    };
  }

  componentDidMount() {
    const sections = [this.props.data.section];
    if (this.props.data.parentSection) {
      sections.unshift(this.props.data.parentSection);
    }
    GA.registerPageView(this.props.pageType, { section: this.props.data.section });
    WebEngage.registerPageView({ section: this.props.data.section });
    EVOLOK.loadScript(this.props.pageType, { collection: this.props });
    DeepBI.registerPageView({ collection: this.props });
  }

  render() {
    const stories = get(this.props.data, ["collection", "items"], []);
    const sectionName = get(this.props.data, ["sectionSlug"], null);

    const sectionSlug = get(this.props.data, ["collection", "slug"], "");
    const section = get(this.props.data, ["section"], {});

    const sectionColor = get(section, ["data", "color"], "#2c2c2c");

    if (stories.length < 1) {
      return (
        <div className={styles["default-section-page"]}>
          <div className={styles["no-stories"]}>
            <h2 className={styles["no-stories-status"]}>No stories found.</h2>
          </div>
        </div>
      );
    }

    const initialStories = get(this.props.data, ["collection", "items"], []);

    return (
      <div className={`${styles["default-section-page"]} ${styles["default-section-page-container"]}`}>
        <div className={styles["section-page"]}>
          <div className={`${styles["page-header"]} container`}>
            <MyVikatanHeader showMenu={true} showBanner={true} />
          </div>
          <div
            className={
              sectionSlug === "cricket-world-cup-2023" ? styles["cricket-collection"] : styles["first-collection"]
            }
          >
            <MyvikatanCollection
              showReadmore={false}
              accentColor={sectionColor}
              collection={{ ...this.props.data.collection, items: initialStories.slice(0, 21) }}
              pagetype="section"
            />
          </div>

          <LoadMoreStoriesBase
            template={StoryListBase}
            numStoriesToLoad={9}
            data={{ stories: [...initialStories] }}
            params={{ section: sectionName, tag: "my vikatan" }}
            fields={FIELDS_FOR_STORY_PAGE}
          />
        </div>

        <div />
        <VikatanSticky placement="bundle" />
        <VikatanDesktopSticky placement="bundle" />
      </div>
    );
  }
}

MyVikatanSectionPage.propTypes = {
  data: PropTypes.shape({
    collection: PropTypes.object,
    section: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    }),
    parentSection: PropTypes.shape({
      name: PropTypes.string,
      data: PropTypes.shape({
        color: PropTypes.string
      })
    })
  }),
  config: PropTypes.shape({}),
  pageType: PropTypes.string
};
